var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"adminActive":_vm.isAdmin,"adminBusy":_vm.busy,"toggleAdmin":_vm.toggleAdmin,"withAdminLock":_vm.withLock})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }